import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useContext } from 'react';
import ContentEditable from '../ReactContenteditable';
import maxWidthMemo from '../maxWidthMemo';
import linkify from '../LinkHandlers';
import { MenuContext } from '../Menu';

var noop = function noop() {};

function Button(_ref) {
  var _ref$content = _ref.content,
      content = _ref$content === void 0 ? '' : _ref$content,
      href = _ref.href,
      target = _ref.target,
      className = _ref.className,
      style = _ref.style,
      edit = _ref.edit,
      _ref$editable = _ref.editable,
      editable = _ref$editable === void 0 ? {} : _ref$editable,
      children = _ref.children,
      _ref$innerClassName = _ref.innerClassName,
      innerClassName = _ref$innerClassName === void 0 ? '' : _ref$innerClassName,
      _ref$uiEvents = _ref.uiEvents,
      uiEvents = _ref$uiEvents === void 0 ? null : _ref$uiEvents;

  var _ref2 = useContext(MenuContext) || {},
      close = _ref2.close;

  var _ref3 = style || {},
      maxWidth = _ref3.maxWidth,
      inlineStyles = _objectWithoutPropertiesLoose(_ref3, ["maxWidth"]);

  var maxWidthStyle = maxWidthMemo(maxWidth);

  if (process.env.ENV_RAW || !edit) {
    var _linkify = linkify({
      href: href,
      target: target
    }),
        Component = _linkify.Component,
        props = _linkify.props;

    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: inlineStyles
    }, /*#__PURE__*/React.createElement(Component, Object.assign({
      className: 'btn ' + innerClassName
    }, props, {
      dangerouslySetInnerHTML: {
        __html: content
      },
      style: maxWidthStyle,
      onClick: close
    })));
  }

  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className,
    style: inlineStyles
  }, uiEvents), /*#__PURE__*/React.createElement(ContentEditable, Object.assign({
    tagName: "a",
    className: 'btn ' + innerClassName,
    href: "#",
    html: content,
    onClick: noop,
    style: maxWidthStyle
  }, editable)), children);
}

Button.className = 'btn-box';
export { Button };